import Client from './client';

export default class OrganizationMembershipCopies extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  postMembershipAndCopies(options = {}) {
    return this.makeRequest(`${this.host}/internal/organization/membership/copies`, {
      ...options,
       method: 'POST',
    });
  }

}
